const apiGateway = require('@buzzfeed/api-gateway');

const getComments = async ({ contentType, contentId, sort = 'hearts', pageSize = 10, childSize = 0 }) => {
  const params = new URLSearchParams({
    content_type: contentType,
    content_id: contentId,
    sort,
    page_size: pageSize,
    child_size: childSize
  });
  const endpoint = `/comments-api/v1/comments?${params.toString()}`;
  try {
    const response = await apiGateway.fetch(endpoint);
    // If the response has a status or ok property, check for success
    if ((response.status && response.status >= 400) || (response.ok === false)) {
      throw new Error(`API Gateway error: ${response.status || ''} ${response.statusText || ''}`);
    }
    if (!response.body) {
      throw new Error('API Gateway response missing body');
    }
    return response.body;
  } catch (error) {
    // Optionally, you could log the error here
    throw new Error(`Failed to fetch comments: ${error.message}`);
  }
};

module.exports = getComments;
